import { TableConfig } from "../../../../../common/tables/config/TableConfig";
import { VariantTableRow } from "../../../../../../../common/tables/product-listing/variants/VariantTableRow";
import { SortOrder } from "../../../../../../../common/query-filters";
import { CellType } from "../../../../../common/tables/config/CellType";

export const DefaultVariantTableConfig: TableConfig<VariantTableRow> = {
    columns: [
        {
            columnName: "id",
            displayName: "Variant ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "130px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "title",
            displayName: "Title",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "sku",
            displayName: "SKU",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "180px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "price",
            displayName: "Price",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "compareAtPrice",
            displayName: "Compare At Price",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "inventoryQuantity",
            displayName: "Quantity",
            cellType: CellType.readOnlyNumber,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "costMetadataCount",
            displayName: "Cost Metadata",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.ASCENDING,
        sortColumn: "sku",
        pageSize: 50,
    },
};
